import * as React from 'react';
import { SVGProps } from 'react';

const IconLeafSizeS = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M13 3c-3 2.5-8 7-12 11l2 2c.433-1.082 1.193-2.258 2.12-3.436 1.712.648 4.91 1.459 6.88-.512 2.792-2.792 3-11.05 3-11.05S6.741 1.209 3.95 4c-1.643 1.643-1.352 4.141-.835 5.919C8.607 4.757 13 3 13 3z" />
  </svg>
);
export default IconLeafSizeS;
